import React from "react";
import PropTypes from "prop-types";
import styles from "./AppContent.module.css";

import { InlineWidget } from "react-calendly";
import { Link } from 'react-scroll';

import profile from "../../images/rics-white-bg.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { 
  FaPalette, 
  FaDatabase, 
  FaAward, 
  FaLink, 
  FaGithub, 
  FaPhoneAlt, 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaFacebookMessenger,
  FaHeartbeat,
  FaTimes
} from "react-icons/fa";

import { BsMouse } from "react-icons/bs";
import { BiChevronDown } from "react-icons/bi";
import { RiChatAiFill } from "react-icons/ri";
import { IoSend } from "react-icons/io5";
import { TbExternalLink } from "react-icons/tb";

import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import fujitsu from "../../images/fujitsu.png"; 
import kodego from "../../images/kodego.png"; 
import chrmo from "../../images/chrmo.jpg"; 
import testdome from "../../images/testdome.jpg";
import eduonix from "../../images/eduonix.jpg";
import freecodecamp from "../../images/freecodecamp.png";
import concati from "../../images/concati.png";
import google from "../../images/googlelogo.png";
import ccc_admission from "../../images/ccc-admission.gif";
import cemetry_mapping from "../../images/cemetery-map.gif";
import fb_clone from "../../images/fb-clone.gif";
import task_organizer from "../../images/task-organizer.gif";
import chat_cortex_1 from "../../images/projects/chat-cortex/chat-cortex.png";
import chat_cortex_2 from "../../images/projects/chat-cortex/chat-cortex-2.png";
import chat_cortex_3 from "../../images/projects/chat-cortex/chat-cortex-3.png";

import todo_app_1 from "../../images/projects/todo-app-nextjs/todo-app-nextjs.png";
import todo_app_2 from "../../images/projects/todo-app-nextjs/todo-app-nextjs-2.png";

import hrms1 from "../../images/projects/hrms/hrms1.png";
import hrms2 from "../../images/projects/hrms/hrms2.png";
import hrms3 from "../../images/projects/hrms/hrms3.png";
import hrms4 from "../../images/projects/hrms/hrms4.png";
import hrms5 from "../../images/projects/hrms/hrms5.png";
import hrms6 from "../../images/projects/hrms/hrms6.png";
import hrms7 from "../../images/projects/hrms/hrms7.png";

import iqas1 from "../../images/projects/iqas/iqas.png";
import iqas2 from "../../images/projects/iqas/iqas2.png";
import iqas3 from "../../images/projects/iqas/iqas3.png";
import iqas4 from "../../images/projects/iqas/iqas4.png";
import iqas5 from "../../images/projects/iqas/iqas5.png";
import iqas6 from "../../images/projects/iqas/iqas6.png";
import iqas7 from "../../images/projects/iqas/iqas7.png";
import iqas8 from "../../images/projects/iqas/iqas8.png";
import iqas9 from "../../images/projects/iqas/iqas9.png";


import valorant from "../../images/valorant.gif";

import tailwindLogo from "../../images/tech-stacks/tailwindcss-mark.svg";
import javascript from "../../images/tech-stacks/javascript-vector-logo-yellow-png-transparent-javascript-vector-12.png";
import reactLogo from "../../images/tech-stacks/reactlogo.png";
import vueLogo from "../../images/tech-stacks/vuelogo.png";
import laravelLogo from "../../images/tech-stacks/laravelLogo.png";
import phpLogo from "../../images/tech-stacks/phplogo.png";
import mysqlLogo from "../../images/tech-stacks/mysql.png";
import nodejsLogo from "../../images/tech-stacks/nodejs.png";

import { useState, useEffect, useRef } from "react";

import AOS from 'aos';

const AppContent = () => {
  const chat_cortex = [chat_cortex_1, chat_cortex_2, chat_cortex_3];
  const todo_app = [todo_app_1, todo_app_2];
  const hrms_app = [hrms1, hrms2, hrms3, hrms4, hrms5, hrms6, hrms7];
  const iqas_app = [iqas1, iqas2, iqas3, iqas4, iqas5, iqas6, iqas7, iqas8, iqas9];

  const [scroll, setScroll] = useState(0);
  const [openChat, setOpenChat] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [messages, setMessages] = useState([
    {
      sender: "bot",
      text: "Hey there! 👋 Thanks for checking out my website. Don't hesitate to ask me anything about programming, web development, or my experience in tech. Happy to help however I can! 😊"
    }
  ]);
  const [input, setInput] = useState("");

  const messagesEndRef = useRef(null);

  const handleChatBot = () => {
    setOpenChat(!openChat);
  };

  const sendMessage = async () => {
    if (!input) return;

    const userMessage = { sender: "user", text: input };

    setMessages((prev) => [...prev, userMessage]);
    setInput("");
    setIsTyping(true);

    try {
      const res = await fetch("https://chat-cortex-server.vercel.app/chatbot", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ message: input }),
      });

      const data = await res.json();

      const botMessage = {
        sender: "bot",
        text: data.reply,
      };

      setMessages((prev) => [...prev, botMessage]);

    } catch (error) {
      console.error(error);
    } finally {
      setIsTyping(false);
    }
  };

  const handleScroll = () => {
    if (window.scrollY > 500) {
      setScroll(1);
    } else {
      setScroll(0);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    AOS.init({
      once: true
    });
  }, []);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className={styles.AppContent} data-testid="AppContent">
      <div className={styles.AppNavbar}>
        <div className={styles.AppNavbarList}>
          <div className={styles.AppNavbarListItem} data-aos="fade-left" data-aos-duration="500" data-aos-delay="100">
            <Link className='text-decoration-none' to="about">
              [ <span>About</span> ]
            </Link>
          </div>
          <div className={styles.AppNavbarListItem} data-aos="fade-left" data-aos-duration="500" data-aos-delay="200">
            <Link className='text-decoration-none' to="experience">
              [ <span>Experience</span> ]
            </Link>
          </div>
          <div className={styles.AppNavbarListItem} data-aos="fade-left" data-aos-duration="500" data-aos-delay="300">
            <Link className='text-decoration-none' to="projects">
              [ <span>Projects</span> ]
            </Link>
          </div>
          <div className={styles.AppNavbarListItem} data-aos="fade-left" data-aos-duration="500" data-aos-delay="400">
            <Link className='text-decoration-none' to="contact">
              [ <span>Contact</span> ]
            </Link>
          </div>
        </div>
      </div>
      <div className={styles.AppContentBody}>
        <div id="about" className="pt-1"></div>
        <div className={styles.AppAbout} data-aos="fade-right" data-aos-duration="500" data-aos-delay="300">
          <div className={styles.AppAboutWrapper}>
            <div className={styles.AppAboutHeader}>
              <h1 className="text-lg-start text-center">
                <span>
                  <b style={{ fontSize: "3rem" }}>A</b>
                  BOUT ME
                </span>
              </h1>
            </div>
            <div className={styles.AppAboutContent}>
              <p className="m-0">
                Hi! I am Rico Guinanao, a full stack web developer. I have experience in developing web-based applications using Laravel and Vue. I am passionate about learning new technologies and improving my skills as a developer.
              </p>
              <p className="m-0 mt-3">
                Aside from coding, I enjoy watching anime, listening to good music, riding motorcycle and traveling.
              </p>
              {/* <p className="m-0 mt-3">
                Explore my portfolio and feel free to contact me if you have any questions and sugggestions.
              </p> */}
            </div>
            <div className={styles.AppTechStacks + " mt-5"}>
              <h1 className="text-lg-start text-center">
                <span>
                  <b style={{ fontSize: "3rem" }}>T</b>ECHNOLOGY STACKS
                </span>
              </h1>
            </div>
            <div className={styles.AppTechStacksContent}>
              <div className="row gx-3 gy-3">
                <div className="col-lg-6">
                  <div className={styles.AppFrontEnd}>
                    <div className={styles.AppFrontEndHeader}>
                      <FaPalette size={25} />
                      <h4 className="text-center m-2">Front-end Tools</h4>
                    </div>
                    <div className={styles.AppFrontEndContent + " mt-3"}>
                      <div className="row gx-3 gy-3">
                        <div className="col-3 d-flex flex-column align-items-center justify-content-center">
                          <div className="p-2 h-100 d-flex align-items-center justify-content-center">
                            <img
                              src={javascript}
                              alt=""
                              width="60vw"
                            />
                          </div>
                          <small
                            className="text-center"
                            style={{ fontSize: "70%" }}
                          >
                            Javascript
                          </small>
                        </div>
                        <div className="col-3 d-flex flex-column align-items-center justify-content-center">
                          <div className="p-2 h-100 d-flex align-items-center justify-content-center">
                            {<img
                              src={tailwindLogo}
                              alt=""
                              width="60vw"
                            />}
                          </div>
                          <small
                            className="text-center"
                            style={{ fontSize: "70%" }}
                          >
                            Tailwind
                          </small>
                        </div>
                        <div className="col-3 d-flex flex-column align-items-center justify-content-center">
                          <div className="p-2 h-100 d-flex align-items-center justify-content-center">
                            <img
                              src={reactLogo}
                              alt=""
                              width="60vw"
                            />
                          </div>
                          <small
                            className="text-center"
                            style={{ fontSize: "70%" }}
                          >
                            React
                          </small>
                        </div>
                        <div className="col-3 d-flex flex-column align-items-center justify-content-center">
                          <div className="p-2 h-100 d-flex align-items-center justify-content-center">
                            <img
                              src={vueLogo}
                              alt=""
                              width="60vw"
                            />
                          </div>
                          <small
                            className="text-center"
                            style={{ fontSize: "70%" }}
                          >
                            Vue
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className={styles.AppBackEnd}>
                    <div className={styles.AppBackEndHeader}>
                      <FaDatabase size={25} />
                      <h4 className="text-center m-2">Back-end Tools</h4>
                    </div>
                    <div className={styles.AppBackEndContent + " mt-3"}>
                      <div className="row gx-3 gy-3">
                        <div className="col-3 d-flex flex-column align-items-center justify-content-center">
                          <div className="p-2 h-100 d-flex align-items-center justify-content-center">
                            <img
                              src={laravelLogo}
                              alt=""
                              width="60vw"
                            />
                          </div>
                          <small
                            className="text-center"
                            style={{ fontSize: "70%" }}
                          >
                            Laravel
                          </small>
                        </div>
                        <div className="col-3 d-flex flex-column align-items-center justify-content-center">
                          <div className="p-2 h-100 d-flex align-items-center justify-content-center">
                            <img
                              src={phpLogo}
                              alt=""
                              width="60vw"
                            />
                          </div>
                          <small
                            className="text-center"
                            style={{ fontSize: "70%" }}
                          >
                            PHP
                          </small>
                        </div>
                        <div className="col-3 d-flex flex-column align-items-center justify-content-center">
                          <div className="p-2 h-100 d-flex align-items-center justify-content-center">
                            <img
                              src={mysqlLogo}
                              alt=""
                              width="60vw"
                            />
                          </div>
                          <small
                            className="text-center"
                            style={{ fontSize: "70%" }}
                          >
                            MySQL
                          </small>
                        </div>
                        <div className="col-3 d-flex flex-column align-items-center justify-content-center">
                          <div className="p-2 h-100 d-flex align-items-center justify-content-center">
                            <img
                              src={nodejsLogo}
                              alt=""
                              width="65vw"
                            />
                          </div>
                          <small
                            className="text-center"
                            style={{ fontSize: "70%" }}
                          >
                            Node
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.AppMouseWrapper}>
              <div className=
                {styles.AppMouse+` ${scroll > 0 ? styles.AppMouseHide : styles.AppMouseShow}`}
              >
                <BsMouse
                  className="text-white fs-5"
                />
                <BiChevronDown
                  className="text-white fs-5"
                />
              </div>
            </div>
          </div>
        </div>
        <div id="experience" className="pt-1"></div>
        <div className={styles.AppExperience} data-aos="fade-right" data-aos-duration="500" data-aos-delay="400">
          <div className={styles.AppExperienceWrapper}>
            <div className={styles.AppExperienceHeader}>
              <h1 className="text-lg-start text-center">
                <span>
                  <b style={{ fontSize: "3rem" }}>E</b>XPERIENCE
                </span>
              </h1>
            </div>
            <div className={styles.AppExperienceContent+" px-3"}>
              <VerticalTimeline
                layout={ "1-column-left" }
                lineColor={ "#fff" }
                animate={ true }
                className={ styles.AppExprienceTimeline }
              >
                <VerticalTimelineElement
                  className={styles.AppExprienceTimelineElement}
                  contentStyle={{ background: '#202020a6', border: "#5f5f5f4f solid 1px", color: '#fff', boxShadow: "none"}}
                  contentArrowStyle={{ borderRight: '20px solid #202020' }}
                  date="Sept 2022 - Present"
                  dateClassName={ styles.AppExperienceDate }
                  iconStyle={{ background: '#00ba7c', color: '#fff', width: '20px', height: '20px', marginLeft: '10px', marginTop: '10px' }}
                  // icon={<FaLink size={10} color="#fff" />}
                  visible={false}
                  iconClassName={styles.Icon}
                >
                  <div className="d-lg-flex align-items-center justify-content-between">
                   {/*  <div className={styles.JobDescription}> */}
                    <div>
                      <h4 className={styles.Position}>Full Stack Web Developer</h4>
                      <div className="d-flex gap-2 mb-2">
                        <img src={fujitsu} alt="kodego" width="20px" height="20px" className=""/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          Fujitsu Die-Tech Corporation of the Philippines
                        </p>
                      </div>
                      <ul className={styles.JobHighlights}>
                        <li>
                          Built and maintain web applications such as Locker Management, Safety and Health Management System, Internal Quality Audit System and Human Resource System.
                        </li>
                        <li>
                          Worked with clients and cross-functional departments by communicating project status, proposals, system design, system requirements, and maintenance.
                        </li>
                        <li>
                          Increased system efficiency by 65% through proactive maintenance and performance optimization.
                        </li>
                      </ul>
                    </div>
                  </div>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                  className={styles.AppExprienceTimelineElement}
                  contentStyle={{ background: '#202020a6', border: "#5f5f5f4f solid 1px", color: '#fff', boxShadow: "none"}}
                  contentArrowStyle={{ borderRight: '20px solid #202020' }}
                  date="Apr 2022 - Aug 2022"
                  dateClassName={ styles.AppExperienceDate }
                  iconStyle={{ background: '#00ba7c', color: '#fff', width: '20px', height: '20px', marginLeft: '10px', marginTop: '10px' }}
                  visible={false}
                  iconClassName={styles.Icon}
                >
                  <div className="d-lg-flex align-items-center justify-content-between">
                    <div className={styles.JobDescription}>
                      <h4 className={styles.Position}>Bootcamp Student</h4>
                      <div className="d-flex gap-2 mb-2">
                        <img src={kodego} alt="kodego" width="20px" height="20px" className=""/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          KodeGo Bootcamp
                        </p>
                      </div>
                      <ul className={styles.JobHighlights}>
                        <li>
                          Joined collaborative hackathon for the first time and won
                          <a class="ms-1 text-decoration-underline text-white" href="https://www.gizguide.com/2022/08/kodego-concati-api-hackathon.html" target="_blank" rel="noopener noreferrer">
                            1st place
                          </a>
                        </li>
                        <li>
                          Created web projects and a capstone.
                        </li>
                        <li>
                          Learned how to use frameworks and libraries such as ReactJS
                          and Laravel as an API.
                        </li>
                      </ul>
                    </div>
                    <div className="p-lg-5 p-3 text-center">
                      <a
                        href="https://assets.kodego.ph/public/isa/wrBkkpRIHG3pPCnEqNY0H5yQuERKmDm0foARc8b2.pdf"
                        className="d-flex text-decoration-none gap-1"
                        target="_blank"
                      >
                        <button className={styles.BtnViewCert+" btn btn-outline-primary rounded-5 d-flex align-items-center justify-content-center "}>
                          <FaAward size={28} />
                          <p className="m-0">View Certificate</p>
                        </button>
                      </a>
                    </div>
                  </div>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                  className={styles.AppExprienceTimelineElement}
                  contentStyle={{ background: '#202020a6', border: "#5f5f5f4f solid 1px", color: '#fff', boxShadow: "none"}}
                  contentArrowStyle={{ borderRight: '20px solid #202020' }}
                  date="Apr 2022 - Jul 2022"
                  dateClassName={ styles.AppExperienceDate }
                  iconStyle={{ background: '#00ba7c', color: '#fff', width: '20px', height: '20px', marginLeft: '10px', marginTop: '10px' }}
                  visible={false}
                  iconClassName={styles.Icon}
                >
                  <div className="d-lg-flex align-items-center justify-content-between">
                    <div className={styles.JobDescription}>
                      <h4 className={styles.Position}>Junior Web Developer</h4>
                      <div className="d-flex gap-2 mb-2">
                        <img src={chrmo} alt="kodego" width="20px" height="20px" className=""/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          Calamba City Human Resource Management Office · Internship
                        </p>
                      </div>
                      <ul className={styles.JobHighlights}>
                      
                        <li>
                          Developed payroll management system for permanent employees of Calamba municipality.
                        </li>
                        <li>
                          Learned Laravel Framework.
                        </li>
                        <li>
                          Learned GitHub and basic MVC (Model-View-Controller) framework.
                        </li>
                      </ul>
                    </div>
                    <div className="p-lg-5 p-3 text-center">
                      <a
                        href="https://drive.google.com/file/d/1Qnze9TggBCrMfUKHNCtIvDB1uQUiEX6c/view"
                        className="d-flex text-decoration-none gap-1"
                        target="_blank"
                      >
                        <button className={styles.BtnViewCert+" btn btn-outline-primary rounded-5 d-flex align-items-center justify-content-center "}>
                          <FaAward size={28} />
                          <p className="m-0">View Certificate</p>
                        </button>
                      </a>
                    </div>
                  </div>
                </VerticalTimelineElement> 
              </VerticalTimeline>
            </div>
          </div>
        </div>
        <div className={styles.AppCertificate}>
          <div className={styles.AppCertificateWrapper}>
            <div className={styles.AppCertificateHeader} data-aos="fade-right" data-aos-duration="500" data-aos-delay="300">
              <h1 className="text-lg-start text-center">
                <span>
                  <b style={{ fontSize: "3rem" }}>C</b>ERTIFICATES
                </span>
              </h1>
            </div>
            <div className="row g-3">
              <div className="col-lg-4 col-md-6 col-sm-6" data-aos="fade-right" data-aos-duration="500" data-aos-delay="400">
                <a
                  href="https://drive.google.com/file/d/1GJQPih-6n8BmfKEBHOSVjmA5-WFy4_ll/view?usp=sharing"
                  className="text-decoration-none gap-1"
                  target="_blank"
                >
                  <div className={styles.AppCertificateContent+" d-flex align-items-center justify-content-between "}>
                    <div className={styles.AppCertificateContentHeader}>
                      <h6 className={styles.AppCertificateContentHeaderTitle}>
                        <span>Kaizen Symposium</span>
                      </h6>
                      <div className="d-flex">
                        <img src={fujitsu} width="20px" height="20px" className="me-1"/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          Fujitsu Die-Tech Corp. of the Philippines
                        </p>
                      </div>
                    </div>
                    <div className={styles.ViewCert}>
                      <FaAward size={25}/>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6" data-aos="fade-right" data-aos-duration="500" data-aos-delay="400">
                <a
                  href="https://coursera.org/share/5f9b03c5b0c82fbc8326bf6ef3b4b663"
                  className="text-decoration-none gap-1"
                  target="_blank"
                >
                  <div className={styles.AppCertificateContent+" d-flex align-items-center justify-content-between "}>
                    <div className={styles.AppCertificateContentHeader}>
                      <h6 className={styles.AppCertificateContentHeaderTitle}>
                        <span>Build Wireframes and Low-Fidelity Prototypes</span>
                      </h6>
                      <div className="d-flex">
                        <img src={google} width="20px" height="20px" className="me-1"/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          Google Course
                        </p>
                      </div>
                    </div>
                    <div className={styles.ViewCert}>
                      <FaAward size={25}/>
                    </div>
                  </div>
                </a>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-6" data-aos="fade-right" data-aos-duration="500" data-aos-delay="400">
                <a
                  href="https://drive.google.com/file/d/18lm_6sFSsAnThm_mlWZJgeXAOD0u5egI/view"
                  className="text-decoration-none gap-1"
                  target="_blank"
                >
                  <div className={styles.AppCertificateContent+" d-flex align-items-center justify-content-between "}>
                    <div className={styles.AppCertificateContentHeader}>
                      <h6 className={styles.AppCertificateContentHeaderTitle}>
                        <span>Elevate Hackathon</span>
                      </h6>
                      <div className="d-flex">
                        <img src={concati} width="20px" height="20px" className="me-1"/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          Concati & KodeGo
                        </p>
                      </div>
                    </div>
                    <div className={styles.ViewCert}>
                      <FaAward size={25}/>
                    </div>
                  </div>
                </a>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-6" data-aos="fade-right" data-aos-duration="500" data-aos-delay="500">
                <a
                  href="https://www.testdome.com/certificates/cfcca8cc568b451f90b1260b86bcf96d"
                  className="text-decoration-none gap-1"
                  target="_blank"
                >
                  <div className={styles.AppCertificateContent+" d-flex align-items-center justify-content-between "}>
                    <div className={styles.AppCertificateContentHeader}>
                      <h6 className={styles.AppCertificateContentHeaderTitle}>
                        <span>PHP Certificate</span>
                      </h6>
                      <div className="d-flex">
                        <img src={testdome} width="20px" height="20px" className="me-1"/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          TestDome
                        </p>
                      </div>
                    </div>
                    <div className={styles.ViewCert}>
                      <FaAward size={25}/>
                    </div>
                  </div>
                </a>
              </div>
              
              <div className="col-lg-4 col-md-6 col-sm-6" data-aos="fade-right" data-aos-duration="500" data-aos-delay="600">
                <a
                  href="https://www.testdome.com/certificates/1306b05b71984d378da7733001c7341e"
                  className="text-decoration-none gap-1"
                  target="_blank"
                >
                  <div className={styles.AppCertificateContent+" d-flex align-items-center justify-content-between "}>
                    <div className={styles.AppCertificateContentHeader}>
                      <h6 className={styles.AppCertificateContentHeaderTitle}>
                        <span>MySQL and SQL Certificate</span>
                      </h6>
                      <div className="d-flex">
                        <img src={testdome} width="20px" height="20px" className="me-1"/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          TestDome
                        </p>
                      </div>
                    </div>
                    <div className={styles.ViewCert}>
                      <FaAward size={25}/>
                    </div>
                  </div>
                </a>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-6" data-aos="fade-right" data-aos-duration="500" data-aos-delay="700">
                <a
                  href="https://www.eduonix.com/certificate/e43f1c027d"
                  className="text-decoration-none gap-1"
                  target="_blank"
                >
                  <div className={styles.AppCertificateContent+" d-flex align-items-center justify-content-between "}>
                    <div className={styles.AppCertificateContentHeader}>
                      <h6 className={styles.AppCertificateContentHeaderTitle}>
                        <span>JavaScript and jQuery Course</span>
                      </h6>
                      <div className="d-flex">
                        <img src={eduonix} width="20px" height="20px" className="me-1"/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          Eduonix
                        </p>
                      </div>
                    </div>
                    <div className={styles.ViewCert}>
                      <FaAward size={25}/>
                    </div>
                  </div>
                </a>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-6" data-aos="fade-right" data-aos-duration="500" data-aos-delay="800">
                <a
                  href="https://www.freecodecamp.org/certification/rics/javascript-algorithms-and-data-structures"
                  className="text-decoration-none gap-1"
                  target="_blank"
                >
                  <div className={styles.AppCertificateContent+" d-flex align-items-center justify-content-between "}>
                    <div className={styles.AppCertificateContentHeader}>
                      <h6 className={styles.AppCertificateContentHeaderTitle}>
                        <span>JavaScript Algorithms and Data Structures</span>
                      </h6>
                      <div className="d-flex">
                        <img src={freecodecamp} width="20px" height="20px" className="me-1"/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          freeCodeCamp
                        </p>
                      </div>
                    </div>
                    <div className={styles.ViewCert}>
                      <FaAward size={25}/>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div id="projects" className="pt-1"></div>
        <div className={styles.AppProjects}>
          <div className={styles.AppProjectWrapper}>
            <div div className={styles.AppProjectHeader} data-aos="fade-right" data-aos-duration="500" data-aos-delay="450">
              <h1 className="text-lg-start text-center mb-4">
                <span>
                  <b style={{ fontSize: "3rem" }}>P</b>ROJECTS
                </span>
              </h1>
            </div>
            {/* <div className="row g-3 mb-3">
              <div className="col-lg-6 col-md-12 col-sm-12" data-aos="fade-right" data-aos-duration="500" data-aos-delay="700">
                <div className={styles.AppProjectContent+" position-relative"}>
                  <div className={styles.AppProjectOverlay+" p-2 d-lg-none"}>
                    <p className="text-white m-0 text-center">Tap for details</p>
                  </div>
                  <div className={styles.AppProjectBackdrop+" d-lg-flex"}>
                    <h5 className="text-white">Chat Cortex</h5>
                    <div class="d-inline-flex align-items-center">
                      <FaLink className="me-1"/>
                      <a href="https://chat-cortex.vercel.app" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">chat-cortex.vercel.app</small>
                      </a>
                    </div>
                    <div class="mb-1 d-flex align-items-center">
                      <FaGithub className="me-1"/>
                      <a href="https://github.com/coricss/chat-cortex" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">coricss/chat-cortex</small>
                      </a>
                    </div>
                    <div className="row row-cols-auto g-0 mt-2 mb-1">
                      <div className="col">
                        <small className="badge bg-success me-1">Vue</small>
                        <small className="badge bg-success">OpenAI</small>
                        <small className="badge bg-success mx-1">ChatGPT</small>
                      </div>
                      
                    </div>
                    <small>Chat Cortex will answer all your questions and it was powered by ChatGPT.</small>
                  </div>
                  <img src={chat_cortex}></img>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12" data-aos="fade-right" data-aos-duration="500" data-aos-delay="700">
                <div className={styles.AppProjectContent+" position-relative"}>
                  <div className={styles.AppProjectOverlay+" p-2 d-lg-none"}>
                    <p className="text-white m-0 text-center">Tap for details</p>
                  </div>
                  <div className={styles.AppProjectBackdrop+" d-lg-flex"}>
                    <h5 className="text-white">Task Organizer</h5>
                    <div class="mb-1 d-flex align-items-center">
                      <FaLink className="me-1"/>
                      <a href="https://todo-app-next-js-corics.vercel.app" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">todo-app-next-js-corics.vercel.app</small>
                      </a>
                    </div>
                    <div class="mb-1 d-flex align-items-center">
                      <FaGithub className="me-1"/>
                      <a href="https://github.com/coricss/todo-app-next-js" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">coricss/todo-app-next-js</small>
                      </a>
                    </div>
                    <div className="row row-cols-auto g-0 mt-2 mb-1">
                      <div className="col">
                        <small className="badge bg-success me-1">Next</small>
                        <small className="badge bg-success">Tailwind CSS</small>
                        <small className="badge bg-success mx-1">API</small>
                      </div>
                      
                    </div>
                    <small>A simple task management app where you can add, edit, and delete tasks.</small>
                  </div>
                  <img src={task_organizer}></img>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12" data-aos="fade-right" data-aos-duration="500" data-aos-delay="700">
                <div className={styles.AppProjectContent+" position-relative"}>
                  <div className={styles.AppProjectOverlay+" p-2 d-lg-none"}>
                    <p className="text-white m-0 text-center">Tap for details</p>
                  </div>
                  <div className={styles.AppProjectBackdrop+" d-lg-flex"}>
                    <h5 className="text-white">Facebook Clone</h5>
                    <div class="d-inline-flex align-items-center">
                      <FaLink className="me-1"/>
                      <a href="https://fb-clone-react-sigma.vercel.app" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">fb-clone-react-sigma.vercel.app</small>
                      </a>
                    </div>
                    <div class="mb-1 d-flex align-items-center">
                      <FaGithub className="me-1"/>
                      <a href="https://github.com/coricss/fb-clone-react" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">coricss/fb-clone-react</small>
                      </a>
                    </div>
                    <div className="row row-cols-auto g-0 mt-2 mb-1">
                      <div className="col">
                        <small className="badge bg-success me-1">React</small>
                        <small className="badge bg-success">Bootstrap</small>
                        <small className="badge bg-success mx-1">CSS</small>
                      </div>
                      
                    </div>
                    <small>First project using React JS. This app does not intend to use for any fraud such as phishing.</small>
                  </div>
                  <img src={fb_clone}></img>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12" data-aos="fade-right" data-aos-duration="500" data-aos-delay="800">
                <div className={styles.AppProjectContent+" position-relative"}>
                  <div className={styles.AppProjectOverlay+" p-2 d-lg-none"}>
                    <p className="text-white m-0 text-center">Tap for details</p>
                  </div>
                  <div className={styles.AppProjectBackdrop+" d-lg-flex"}>
                    <h5 className="text-white">Valorant E-commerce Design</h5>
                    <div class="d-inline-flex align-items-center">
                      <FaLink className="me-1"/>
                      <a href="https://coricss.github.io/valorant-ecommerce-design/home.html" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">coricss.github.io/valorant-ecommerce-design</small>
                      </a>
                    </div>
                    <div class="mb-1 d-flex align-items-center">
                      <FaGithub className="me-1"/>
                      <a href="https://github.com/coricss/valorant-ecommerce-design" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">coricss/valorant-ecommerce-design</small>
                      </a>
                    </div>
                    <div className="row row-cols-auto g-0 mb-1">
                      <div className="col">
                        <small className="badge bg-success me-1">HTML</small>
                        <small className="badge bg-success me-1">CSS</small>
                      </div>
                      <div className="col">
                      <small className="badge bg-success">Bootstrap</small>
                        <small className="badge bg-success m-1">JavaScript</small>
                      </div>
                    </div>
                    <small>Multipage e-commerce design for Valorant gun skins.</small>
                  </div>
                  <img src={valorant}></img>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12" data-aos="fade-right" data-aos-duration="500" data-aos-delay="500">
                <div className={styles.AppProjectContent+" position-relative"}>
                  <div className={styles.AppProjectOverlay+" p-2 d-lg-none"}>
                    <p className="text-white m-0 text-center">Tap for details</p>
                  </div>
                  <div className={styles.AppProjectBackdrop+" d-lg-flex"}>
                    <h5 className="text-white">Student Admission Management</h5>
                    <div class="d-inline-flex align-items-center">
                      <FaLink className="me-1"/>
                      <a href="https://ccc-admission.epizy.com " target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">ccc-admission.epizy.com </small>
                      </a>
                    </div>
                    <div className="row row-cols-auto g-0 mt-2 mb-1">
                      <div className="col">
                        <small className="badge bg-success me-1">Bootstrap</small>
                        <small className="badge bg-success me-1">JavaScript</small>
                      </div>
                      <div className="col">
                        <small className="badge bg-success">PHP</small>
                        <small className="badge bg-success m-1">MySQL</small>
                      </div>
                    </div>
                    <small>Online pre-registration with LAN-based Entrace Examination for Student Admission in City College of Calamba.</small>
                  </div>
                  <img src={ccc_admission}></img>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12" data-aos="fade-right" data-aos-duration="500" data-aos-delay="600">
                <div className={styles.AppProjectContent+" position-relative"}>
                  <div className={styles.AppProjectOverlay+" p-2 d-lg-none"}>
                    <p className="text-white m-0 text-center">Tap for details</p>
                  </div>
                  <div className={styles.AppProjectBackdrop+" d-lg-flex"}>
                    <h5 className="text-white">Cemetery Mapping</h5>
                    <div class="d-inline-flex align-items-center">
                      <FaLink className="me-1"/>
                      <a href="https://divinelifememorialpark.great-site.net" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">divinelifememorialpark.great-site.net</small>
                      </a>
                    </div>
                    <div class="mb-1 d-flex align-items-center">
                      <FaGithub className="me-1"/>
                      <a href="https://github.com/coricss/cemetery-mapping" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">coricss/cemetery-mapping</small>
                      </a>
                    </div>
                    <div className="row row-cols-auto g-0 mb-1">
                      <div className="col">
                        <small className="badge bg-success">Bootstrap</small>
                        <small className="badge bg-success mx-1">CSS</small>
                        <small className="badge bg-success me-1">JavaScript</small>
                      </div>
                      <div className="col">
                        <small className="badge bg-success">PHP</small>
                        <small className="badge bg-success m-1">MySQL</small>
                      </div>
                    </div>
                    <small>Track your deceased family member's grave.</small>
                  </div>
                  <img src={cemetry_mapping}></img>
                </div>
              </div>
            </div> */}

             <div className={styles.AppProjectImage+" row g-3 mb-5"}>
              <div className="col-md-6">
                <div>
                  <Swiper
                    spaceBetween={30}
                    effect={'fade'}
                    navigation={true}
                    pagination={{
                      clickable: true,
                    }}
                    loop={true}
                    modules={[EffectFade, Navigation, Pagination]}
                    className="mySwiper"
                  >
                    {
                      iqas_app.map((img, i) => (
                        <SwiperSlide key={i}>
                          <img src={img} alt="" />
                        </SwiperSlide>
                      ))
                    }
                  </Swiper>
                </div>
              </div>
              <div className="col-md-6">
                <h4 style={{color: "#00ba7c", fontWeight: "800", fontFamily: "Inter", textTransform: "uppercase"}}>Internal Quality Audit System</h4>
                <div className="row row-cols-auto g-0 mt-2 mb-1">
                    <div className="d-flex gap-1">
                      <small className="badge bg-success">Vue</small>
                      <small className="badge bg-success">Tailwind CSS</small>
                      <small className="badge bg-success">Laravel</small>
                      <small className="badge bg-success">MySQL</small>
                    </div>
                </div>
                <small className="text-white">
                  Created Internal Quality Audit System for Fujitsu Die-Tech Corporation of the Philippines to streamline quality control processes. The system was built using Vue, Tailwind CSS, Laravel, and MySQL, resulting in paperless audit processes.
                </small>
                {/* <div className="mt-4 d-flex align-items-center gap-3">
                   <a href="https://github.com/coricss/chat-cortex.git" target="_blank" rel="noreferrer" className="text-decoration-none">
                    <button className={styles.AppViewGithubButton+" btn btn-primary rounded-3 d-flex align-items-center p-2 justify-content-center"}>
                      <FaGithub className="me-2" size={18}/>
                      <small>View Github</small>
                    </button>
                  </a>
                  <a  href="https://chat-cortex.vercel.app" target="_blank" rel="noreferrer" className="d-flex align-items-center text-white text-decoration-none">
                    <TbExternalLink className="me-2" size={20}/>
                    <small>Live Demo</small>
                  </a>
                </div> */}
              </div>
            </div>

            <div className={styles.AppProjectImage+" row g-3 mb-5"}>
              <div className="col-md-6">
                <div>
                  <Swiper
                    spaceBetween={30}
                    effect={'fade'}
                    navigation={true}
                    pagination={{
                      clickable: true,
                    }}
                    loop={true}
                    modules={[EffectFade, Navigation, Pagination]}
                    className="mySwiper"
                  >
                    {
                      hrms_app.map((img, i) => (
                        <SwiperSlide key={i}>
                          <img src={img} alt="" />
                        </SwiperSlide>
                      ))
                    }
                  </Swiper>
                </div>
              </div>
              <div className="col-md-6">
                <h4 style={{color: "#00ba7c", fontWeight: "800", fontFamily: "Inter", textTransform: "uppercase"}}>Human Resource Management System</h4>
                <div className="row row-cols-auto g-0 mt-2 mb-1">
                    <div className="d-flex gap-1">
                      <small className="badge bg-success">Php</small>
                      <small className="badge bg-success">MySQL</small>
                      <small className="badge bg-success">JavaScript</small>
                      <small className="badge bg-success">Bootstrap</small>
                    </div>
                </div>
                <small className="text-white">
                  Developed a Human Resource Management System for Fujitsu Die-Tech Corporation of the Philippines to manage employee information, attendance, and payroll. The system was built using PHP, MySQL, JavaScript, and Bootstrap, resulting in a 65% increase in efficiency for HR processes.
                </small>
                {/* <div className="mt-4 d-flex align-items-center gap-3">
                   <a href="https://github.com/coricss/chat-cortex.git" target="_blank" rel="noreferrer" className="text-decoration-none">
                    <button className={styles.AppViewGithubButton+" btn btn-primary rounded-3 d-flex align-items-center p-2 justify-content-center"}>
                      <FaGithub className="me-2" size={18}/>
                      <small>View Github</small>
                    </button>
                  </a>
                  <a  href="https://chat-cortex.vercel.app" target="_blank" rel="noreferrer" className="d-flex align-items-center text-white text-decoration-none">
                    <TbExternalLink className="me-2" size={20}/>
                    <small>Live Demo</small>
                  </a>
                </div> */}
              </div>
            </div>

            <div className={styles.AppProjectImage+" row g-3 mb-5"}>
              <div className="col-md-6">
                <div>
                  <Swiper
                    spaceBetween={30}
                    effect={'fade'}
                    navigation={true}
                    pagination={{
                      clickable: true,
                    }}
                    loop={true}
                    modules={[EffectFade, Navigation, Pagination]}
                    className="mySwiper"
                  >
                    {
                      chat_cortex.map((img, i) => (
                        <SwiperSlide key={i}>
                          <img src={img} alt="" />
                        </SwiperSlide>
                      ))
                    }
                  </Swiper>
                </div>
              </div>
              <div className="col-md-6">
                <h4 style={{color: "#00ba7c", fontWeight: "800", fontFamily: "Inter", textTransform: "uppercase"}}>Chat Cortex</h4>
                <div className="row row-cols-auto g-0 mt-2 mb-1">
                    <div className="d-flex gap-1">
                      <small className="badge bg-success">Vue</small>
                      <small className="badge bg-success">Node</small>
                      <small className="badge bg-success">OpenAI</small>
                      <small className="badge bg-success">ChatGPT</small>
                    </div>
                </div>
                <small className="text-white">A generative chat box AI that answers your questions using GPT model.</small>
                <div className="mt-4 d-flex align-items-center gap-3">
                   <a href="https://github.com/coricss/chat-cortex.git" target="_blank" rel="noreferrer" className="text-decoration-none">
                    <button className={styles.AppViewGithubButton+" btn btn-primary rounded-3 d-flex align-items-center p-2 justify-content-center"}>
                      <FaGithub className="me-2" size={18}/>
                      <small>View Github</small>
                    </button>
                  </a>
                  <a  href="https://chat-cortex.vercel.app" target="_blank" rel="noreferrer" className="d-flex align-items-center text-white text-decoration-none">
                    <TbExternalLink className="me-2" size={20}/>
                    <small>Live Demo</small>
                  </a>
                </div>
              </div>
            </div>
            <div className={styles.AppProjectImage+" row g-3 mb-3"}>
              <div className="col-md-6">
                <div>
                  <Swiper
                    spaceBetween={30}
                    effect={'fade'}
                    navigation={true}
                    pagination={{
                      clickable: true,
                    }}
                    loop={true}
                    modules={[EffectFade, Navigation, Pagination]}
                    className="mySwiper"
                  >
                    {
                      todo_app.map((img, i) => (
                        <SwiperSlide key={i}>
                          <img src={img} alt="" />
                        </SwiperSlide>
                      ))
                    }
                  </Swiper>
                </div>
              </div>
              <div className="col-md-6">
                <h4 style={{color: "#00ba7c", fontWeight: "800", fontFamily: "Inter", textTransform: "uppercase"}}>Todo App</h4>
                <div className="row row-cols-auto g-0 mt-2 mb-1">
                    <div className="d-flex gap-1">
                      <small className="badge bg-success">Next</small>
                      <small className="badge bg-success">Rest API</small>
                    </div>
                </div>
                <small className="text-white">A task management tool that create, update and delete task.</small>
                <div className="mt-4 d-flex align-items-center gap-3">
                   <a href="https://github.com/coricss/todo-app-next-js" target="_blank" rel="noreferrer" className="text-decoration-none">
                    <button className={styles.AppViewGithubButton+" btn btn-primary rounded-3 d-flex align-items-center p-2 justify-content-center"}>
                      <FaGithub className="me-2" size={18}/>
                      <small>View Github</small>
                    </button>
                  </a>
                  <a  href="https://todo-app-next-js-corics.vercel.app/login" target="_blank" rel="noreferrer" className="d-flex align-items-center text-white text-decoration-none">
                    <TbExternalLink className="me-2" size={20}/>
                    <small>Live Demo</small>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="contact" className="pt-1"></div>
        <div className={styles.AppContact} data-aos="fade-right" data-aos-duration="500" data-aos-delay="300">
          <div className={styles.AppContactWrapper}>
            <div div className={styles.AppContactHeader}>
              <h1 className="text-lg-start text-center">
                <span>
                  <b style={{ fontSize: "3rem" }}>L</b>ET'S GET IN TOUCH
                </span>
              </h1>
            </div>
            <div className={styles.AppContactBody}>
              <div className={styles.AppContactContent}>
                <div className="mb-4">
                  <p>
                    Feel free to message me if you have any questions or want to work with me. You can find my contact details below and I'll do my best to respond as soon as possible.
                  </p>
                </div>
                <div className="row g-3 mb-4">
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <div className="d-flex align-items-center justify-content-center">
                      <div>
                        {/* <div className="d-flex align-items-center mb-2">
                          <FaPhoneAlt className={styles.AppContactIcons+" me-2"}/>
                          <a href="tel:09319542169" className={styles.AppContactLink+" m-0 text-decoration-none text-white"}>09319542169</a>
                        </div> */}
                        <div className="d-flex align-items-center mb-2">
                          <FaEnvelope className={styles.AppContactIcons+" me-2"}/>
                          <a href="mailto:ricoguinanao.career@gmail.com" className={styles.AppContactLink+" m-0 text-decoration-none text-white"}>ricoguinanao.career@gmail.com</a>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <FaMapMarkerAlt className={styles.AppContactIcons+" me-2"}/>
                          <a href="https://www.google.com/maps/place/Calamba,+4027+Laguna/@14.1865838,121.1205693,2693m/data=!3m1!1e3!4m5!3m4!1s0x33bd63655ce077d3:0x39dd1f59c6edaced!8m2!3d14.1876712!4d121.1250825" target="_blank" className={styles.AppContactLink+" m-0 text-decoration-none text-white"}>Calamba, Laguna, Philippines</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <div className="d-flex align-items-center justify-content-center h-100">
                        <a className="" href="https://www.facebook.com/messages/t/ricstrbo" target="_blank">
                          <button className={styles.AppMessenger+" btn btn-primary rounded-5 btn-lg"}>
                            <FaFacebookMessenger className="me-2"/>
                            <small>Let's chat</small>
                          </button>
                        </a>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <InlineWidget
                    styles={{padding: "0px", height: "800px", width: "100%", overflow: "hidden"}}
                    url="https://calendly.com/guinanaorico/discovery-session?hide_gdpr_banner=1"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {!openChat && (<button onClick={handleChatBot} className={styles.AppFloatingButton + " btn btn-primary rounded-5 btn-sm d-flex align-items-center p-3 justify-content-center"}>
          <RiChatAiFill 
            size={20}
            className="me-2"
          />
          <small>Ask Rico</small>
        </button>)}
        {/* Chatbox */}
        {openChat && (
          <div
            className={`position-fixed bottom-0 end-0 m-4 shadow ${
              openChat ? styles.chatOpen : styles.chatClose
            }`}
            style={{
              minWidth: "320px",
              width: "20vw",
              height: "600px",
              zIndex: "1000",
              borderRadius: "10px",
              background: "#252525",
              border: "1px solid #5f5f5f4f",
              pointerEvents: openChat ? "auto" : "none" 
            }}
          >
            {/* Header */}
            <div className="text-white p-3 d-flex align-items-center justify-content-between gap-2" style={{height: "60px", background: "#00ba7c", borderRadius: "10px 10px 0px 0px"}}>
              <div className="d-flex align-items-center gap-2">
                <img src={profile} style={{height: "35px", borderRadius: "100%"}} alt="Rico Guinanao"></img>
                <span className="fw-bold">Rico Guinanao</span>
              </div>
              <FaTimes style={{cursor: "pointer"}} size={20} onClick={handleChatBot}/>
            </div>
            {/* Messages */}
            <div
              style={{
                height: "470px",
                overflowY: "auto",
                padding: "10px",
              }}
            >
              {messages.map((msg, index) => (
                <div
                  key={index}
                  className={`d-flex mb-2 ${
                    msg.sender === "user" ? "justify-content-end" : "justify-content-start"
                  }`}
                >
                  {msg.sender === "user" ? (
                    <div className="d-flex justify-content-end mb-2">
                      <div className={`${styles.chatBubble} ${styles.chatUser}`}>
                         <small>{msg.text}</small>
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex mb-2">
                      <img
                        src={profile}
                        style={{ height: "25px", borderRadius: "100%", marginRight: "6px" }}
                        alt="Rico Guinanao"
                      />

                      <div>
                        <small className="text-white d-block mb-1">Rico Guinanao</small>

                        <div className={`${styles.chatBubble} ${styles.chatBot}`}>
                          <small>{msg.text}</small>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}

              {isTyping && (
                <div className="d-flex mb-2 justify-content-start">
                  <div className="d-flex mb-2">
                    <img
                      src={profile}
                      style={{ height: "25px", borderRadius: "100%", marginRight: "6px" }}
                      alt="Rico Guinanao"
                    />

                    <div>
                      <small className="text-white d-block mb-1">Rico Guinanao</small>

                      <div className={`${styles.chatBubble} ${styles.chatBot}`}>
                        <div className="d-flex align-items-center justify-content-center gap-1">
                          <span className={styles.dot}></span>
                          <span className={styles.dot}></span>
                          <span className={styles.dot}></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div ref={messagesEndRef} />
            </div>

              {/* Footer */}
              {/* <div
                className="d-flex align-items-center justify-content-center gap-1"
                style={{
                  position: "absolute", // 👈 relative to parent
                  bottom: 0,
                  width: "100%",
                  padding: "5px 10px",
                  textAlign: "center",
                  color: "#999",
                  fontSize: "12px",
                  borderTop: "1px solid #333",
                }}
              >
                <small>Powered by</small>
                <img src={groq} width="40px"/>
              </div> */}


            {/* Input */}
            <div className="p-2 border-top">
              <div className="position-relative">
                <input
                  className="form-control pe-5"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  placeholder="Type a message..."
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault(); 
                      sendMessage();
                    }
                  }}
                />

                <IoSend
                  size={22}
                  onClick={sendMessage}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: input.trim() ? "#00ba7c" : "gray",
                    pointerEvents:  input.trim() ? "" : "none"
                  }}
                />
              </div>
            </div>
          </div>
        )}
        <footer>
          <div className="text-white text-center p-4">
            Created with <FaHeartbeat className="text-success mx-1"/> by <a href="https://github.com/coricss" className="text-decoration-none text-success fw-bold">Rico Guinanao</a>
          </div>
        </footer>
      </div>
    </div>
  );
};

AppContent.propTypes = {};

AppContent.defaultProps = {};

export default AppContent;
